module.exports = __webpack_public_path__ + "img/rm2.490471d6.jpg";